import React from "react";
import Verify from "./wholesale.svg";
import Speed from "./flameproduct.svg";
import Targeter from "./businesstime.svg";

function Reseller() {
  return (
    <>
      <div className="bgi-no-repeat bgi-size-cover bgi-position-x-center bgi-position-y-bottom brand-bg">
        <div className="container">
          <div className="d-flex">
            <div className="d-none d-lg-block">
              <img
                src={"./resources/img/3rdretailreseller5.svg"}
                className={"brandimg1"}
                alt="animate"
                width="950px"
                height="982px"
              />
            </div>

            <div className="min-h-350px min-h-lg-600px px-9">
              <div className="text-justify mb-2 mt-8 mb-lg-2 d-sm-block py-10 py-lg-20 ">
                <h4 className="fs-3x fs-lg-3x mb-2">
                  Resellers Discover Incredible <br></br>Products
                </h4>
                <div className="lineBefore mb-3"></div>
                <p className="my-12">
                  Thousands of wholesale Buyers rely on 3rd Retail to discover
                  and stock the world's<br></br> most interesting products.
                  Using a combination of real people and smart technology, We
                  make it fast and easy to find and stock Brands that you love
                </p>

                <div>
                  <div className="d-flex mb-5">
                    <img
                      src={Verify}
                      width="50px"
                      height="50px"
                      alt="vector1"
                    />
                    <div className="flex-grow-1 ms-6">
                      <h5>Simplify your wholesale buying</h5>
                      <p>
                        With our 24/7 hassle-free and time effective sourcing
                        and stocking, wholesale buying is easier than you knew
                      </p>
                    </div>
                  </div>
                  <div className="d-flex my-5">
                    <img src={Speed} width="50px" height="50px" alt="vector1" />
                    <div className="flex-grow-1 ms-6">
                      <h5>Discover quality products consumers will love</h5>
                      <p>
                        3rdRetail's recommended Brands are high quality and
                        tailored to your individual needs, so you can go from
                        discovering to stocking products that are trusted
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex mt-5">
                      <img
                        src={Targeter}
                        width="50px"
                        height="50px"
                        alt="vector1"
                      />
                      <div className="flex-grow-1 ms-6">
                        <h5>Do business on your own terms</h5>
                        <p>
                          Search, discover and order products that are curated
                          especially for your store
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <a href="/Pagenotfound.html" className="btn btn-lg brandBtn">
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Reseller;
